import type { NewsItem } from "@/types/media";

export const newsList: NewsItem[] = [
  {
    id: "n-001",
    title: "《星海归途》票房突破十五亿，科幻类型迎来创作新热潮",
    category: "电影新闻",
    date: "2024-07-02",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20photo%20of%20a%20crowded%20modern%20cinema%20lobby%20with%20warm%20ambient%20lighting%20and%20movie%20posters%20on%20the%20wall%2C%20blurred%20audience%20in%20motion%2C%20cinematic%20warm%20and%20blue%20tones%2C%20professional%20magazine%20photography%2C%20high%20detail&width=800&height=500&seq=news-001&orientation=landscape",
    summary:
      "上映三周以来，《星海归途》凭借扎实的叙事与震撼的视觉效果持续领跑票房榜，也让业内重新审视国产科幻的创作潜力。",
    content: [
      "上映三周，《星海归途》累计票房正式突破十五亿，稳居同期影片票房榜首的位置。影片凭借扎实的剧本、细腻的人物刻画与高水准的视觉效果，赢得了观众与影评人的一致好评。",
      "有业内人士指出，这部作品的成功并非偶然。近年来，科幻题材在创作、制作与工业化流程上都取得了长足进步，越来越多的创作者开始尝试用类型化的语言讲述属于本土的故事。",
      "与此同时，围绕科幻创作的讨论也愈发热烈。如何在宏大设定与真实情感之间取得平衡，如何让技术服务于叙事而非喧宾夺主，成为创作者们共同面对的课题。可以预见，一股新的科幻创作热潮正在形成。",
    ],
  },
  {
    id: "n-002",
    title: "春季影展公布入围名单，多部新片角逐最佳影片",
    category: "电影新闻",
    date: "2024-06-18",
    cover:
      "https://readdy.ai/api/search-image?query=Elegant%20editorial%20photo%20of%20a%20film%20festival%20red%20carpet%20entrance%20at%20dusk%20with%20warm%20decorative%20lights%2C%20abstract%20photographers%20silhouettes%2C%20sophisticated%20amber%20and%20navy%20tones%2C%20professional%20magazine%20photography%2C%20high%20detail&width=800&height=500&seq=news-002&orientation=landscape",
    summary:
      "本届影展入围名单正式揭晓，多部风格各异的新片成功入围，题材涵盖家庭、犯罪与科幻等多个方向。",
    content: [
      "本届春季影展入围名单于近日正式公布，共有二十余部影片入围主竞赛单元，题材与风格呈现前所未有的多样性。",
      "从聚焦普通人生活的温情故事，到结构精巧的犯罪类型片，再到想象力充沛的科幻作品，入围影片展现了当下创作生态的丰富面貌。多部由青年导演执导的作品尤其受到关注。",
      "影展组委会表示，希望为更多有想法、有表达的创作者提供展示的舞台，也期待与观众一起，在光影中展开更深入的对话。",
    ],
  },
  {
    id: "n-003",
    title: "《长夜将明》收官口碑走高，悬疑剧叙事结构再受关注",
    category: "电视剧资讯",
    date: "2024-05-28",
    cover:
      "https://readdy.ai/api/search-image?query=Moody%20editorial%20photo%20of%20a%20dim%20modern%20office%20at%20night%20with%20stacked%20case%20files%20and%20a%20single%20desk%20lamp%2C%20long%20shadows%2C%20deep%20navy%20and%20amber%20tones%2C%20cinematic%20mood%2C%20professional%20magazine%20photography%2C%20high%20detail&width=800&height=500&seq=news-003&orientation=landscape",
    summary:
      "《长夜将明》近日正式收官，口碑持续走高。其多线并进的叙事结构与扎实的人物塑造，成为观众热议的焦点。",
    content: [
      "作为本季度备受关注的悬疑剧，《长夜将明》日前迎来收官，豆瓣评分稳定在八分以上，讨论热度居高不下。",
      "观众普遍认为，该剧最大的亮点在于叙事结构的精妙。全剧采用多线并进的方式，将案件的侦破过程与人物的内心挣扎交织在一起，既有紧张刺激的推进，也不乏对现实议题的关照。",
      "有评论指出，近年来悬疑剧在数量增长的同时，也愈发注重叙事质量与人文深度。如何在类型框架内讲好一个有温度的故事，正在成为行业共同的追求。",
    ],
  },
  {
    id: "n-004",
    title: "流媒体平台加大原创投入，短剧集成为内容新趋势",
    category: "行业动态",
    date: "2024-05-12",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20abstract%20editorial%20photo%20of%20streaming%20media%20concept%2C%20rows%20of%20glowing%20screens%20in%20a%20dark%20gallery%20space%2C%20teal%20and%20warm%20orange%20accents%2C%20futuristic%20yet%20elegant%2C%20professional%20magazine%20photography%2C%20high%20detail&width=800&height=500&seq=news-004&orientation=landscape",
    summary:
      "多家流媒体平台宣布加大原创内容投入，节奏紧凑、篇幅精炼的短剧集，正成为行业竞相布局的新方向。",
    content: [
      "随着观众收视习惯的变化，越来越多的流媒体平台开始把资源投向原创内容，其中篇幅精炼、节奏紧凑的短剧集备受青睐。",
      "与传统长剧相比，短剧集在叙事上更强调聚焦与效率，往往以更短的篇幅完成完整的故事表达，也更适应观众碎片化的观看需求。",
      "业内人士认为，短剧集的兴起并不意味着长剧的式微，而是内容形态变得更加多元。平台与创作者需要做的，是在不同体量中找到各自最合适的表达方式。",
    ],
  },
  {
    id: "n-005",
    title: "《我们的十年》热播，青春题材回归真实质感",
    category: "电视剧资讯",
    date: "2024-04-30",
    cover:
      "https://readdy.ai/api/search-image?query=Nostalgic%20editorial%20photo%20of%20a%20warm%20sunlit%20schoolyard%20at%20golden%20hour%20with%20long%20shadows%20and%20a%20distant%20bicycle%2C%20soft%20orange%20and%20mint%20tones%2C%20bittersweet%20cinematic%20mood%2C%20professional%20magazine%20photography%2C%20high%20detail&width=800&height=500&seq=news-005&orientation=landscape",
    summary:
      "《我们的十年》开播后口碑持续攀升，写实的人物与细腻的情感，让青春题材重新赢得观众的共鸣。",
    content: [
      "正在热播的《我们的十年》，凭借对青春岁月的真实描摹，收获了大量好评。剧集没有刻意营造戏剧化的冲突，而是把镜头对准了成长中的细碎日常。",
      "许多观众表示，剧中的人物与情节让人倍感亲切，仿佛看到了自己的影子。这种贴近生活的真实感，正是该剧最打动人的地方。",
      "也有评论认为，青春题材的创作正在回归理性，不再依赖套路化的标签，而是更加注重对真实情感的捕捉与表达。",
    ],
  },
  {
    id: "n-006",
    title: "影视工业化提速，虚拟制作技术进入规模化应用阶段",
    category: "行业动态",
    date: "2024-04-15",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20photo%20of%20a%20virtual%20production%20film%20set%20with%20a%20huge%20curved%20LED%20wall%20and%20camera%20rig%2C%20abstract%20behind%20the%20scenes%20atmosphere%2C%20cool%20teal%20and%20warm%20amber%20accents%2C%20professional%20magazine%20photography%2C%20high%20detail&width=800&height=500&seq=news-006&orientation=landscape",
    summary:
      "虚拟制作技术正从实验走向规模化应用，越来越多的剧组开始借助新技术，提升拍摄效率与画面表现力。",
    content: [
      "曾经只出现在少数大制作中的虚拟制作技术，如今正加速走向普及。越来越多的剧组开始采用LED环幕与实时渲染相结合的拍摄方式。",
      "相比传统绿幕，虚拟制作能够在拍摄现场实时呈现背景画面，不仅提升了演员的表演体验，也大幅缩短了后期制作的周期。",
      "业内专家表示，技术的进步最终要服务于内容。如何让新技术真正为叙事赋能，而不是沦为炫技的工具，依然是创作者需要持续思考的问题。",
    ],
  },
];